/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetOwnerInput
 */
export interface SetOwnerInput {
    /**
     * 
     * @type {boolean}
     * @memberof SetOwnerInput
     */
    isOwner?: boolean;
}

/**
 * Check if a given object implements the SetOwnerInput interface.
 */
export function instanceOfSetOwnerInput(value: object): value is SetOwnerInput {
    return true;
}

export function SetOwnerInputFromJSON(json: any): SetOwnerInput {
    return SetOwnerInputFromJSONTyped(json, false);
}

export function SetOwnerInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetOwnerInput {
    if (json == null) {
        return json;
    }
    return {
        
        'isOwner': json['isOwner'] == null ? undefined : json['isOwner'],
    };
}

export function SetOwnerInputToJSON(json: any): SetOwnerInput {
    return SetOwnerInputToJSONTyped(json, false);
}

export function SetOwnerInputToJSONTyped(value?: SetOwnerInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isOwner': value['isOwner'],
    };
}

